module.exports = __webpack_public_path__ + "img/visa_white.32de033f.svg";